
const LoadingComponent = () =>{
     
    return(
        <>
          <div className="spinner-wrapper">
      <div className="spinner"></div>
    </div>
        </>    
    )
    
}

export default LoadingComponent;